import DefaultAnalyticsConfig from "../../../src/common/analytics/defaultAnalyticsConfig";

let erTag = DefaultAnalyticsConfig.erTag;
if (process.env.ENV === "production") {
  erTag = "abcaab578e0c4f2b856a7cd863fe10eb";
}

export default class analyticsConfig extends DefaultAnalyticsConfig {
  static gaTag = "UA-119793932-17";
  static erTag = erTag;
  static erUserReferenceType = "subscriptionReference";
}



// WEBPACK FOOTER //
// ./clients/ALO-OPC/js/analyticsConfig.js